import { api } from "@/lib/api";

// localStorage usage here is intentional and safe:
//   - ANON_KEY stores a random anonymous tracking id (not a credential)
//   - No PII or auth tokens are ever stored client-side; the auth session
//     lives in an httpOnly cookie set by the backend.
const ANON_KEY = "rt_anon_id";

const getAnonId = () => {
  if (typeof window === "undefined") return "";
  let id = localStorage.getItem(ANON_KEY);
  if (!id) {
    id = `anon_${Math.random().toString(36).slice(2)}_${Date.now().toString(36)}`;
    localStorage.setItem(ANON_KEY, id);
  }
  return id;
};

export const trackEvent = async (event, props = {}) => {
  try {
    await api.post("/analytics/event", {
      event,
      props,
      anon_id: getAnonId(),
      path: typeof window !== "undefined" ? window.location.pathname : "",
    });
  } catch (e) {
    // Analytics failures must never break UX. Log in dev for visibility.
    if (process.env.NODE_ENV !== "production") {
      console.warn("[analytics] trackEvent failed", event, e?.response?.status || e?.message);
    }
  }
};
